<!-- contact -->
<template>
  <div class="contact">
    <div class="bgBox section1">
      <div class="s1_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1"><span>联系</span>我们</div>
          <div class="p2"></div>
          <div class="p3">CONTACT US</div>
        </div>
        <div class="bodyBox">
          <div class="left">
            <el-carousel
              indicator-position="outside"
              trigger="click"
              :interval="10000"
            >
              <el-carousel-item :key="1" class="key1">
                <div class="downLoad" @click="downLoad(1)">下载名片</div>
                <img src="../../static/images/contact/李亮名片PC.jpg" alt="" />
              </el-carousel-item>
              <el-carousel-item :key="2" class="key2">
                <div class="downLoad" @click="downLoad(2)">下载名片</div>
                <img
                  src="../../static/images/contact/章桂华名片PC.jpg"
                  alt=""
                />
              </el-carousel-item>
              <el-carousel-item :key="3" class="key1">
                <div class="downLoad" @click="downLoad(3)">下载名片</div>
                <img src="../../static/images/contact/何利名片PC.jpg" alt="" />
              </el-carousel-item>
              <el-carousel-item :key="4" class="key4">
                <div class="downLoad" @click="downLoad(4)">下载名片</div>
                <img
                  src="../../static/images/contact/李志平名片PC.jpg"
                  alt=""
                />
              </el-carousel-item>
            </el-carousel>
            <!-- <div class="p1">深圳市赛迈特新材料有限公司</div>
            <div class="line"></div>
            <div class="item item1">
              <img src="../../static/images/contact/地址.png" alt="">
              <div class="label">公司地址：</div>
              <div class="text">深圳市坪山区兰金四路19号华瀚科技工业园3号厂房2层</div>
            </div>
            <div class="item">
              <img src="../../static/images/contact/服务热线.png" alt="">
              <div class="label">服务热线：</div>
              <div class="text">座<span style="visibility: hidden;">占</span>机（+86 0755-29128802）</div>
            </div>
            <div class="item">
              <img class="visd" src="../../static/images/contact/服务热线.png" alt="">
              <div class="label visd">服务热线：</div>
              <div class="text">何女士（+86 191 2839 0596 / +86 186 8155 9268）</div>
            </div>
            <div class="item item2">
              <img class="visd" src="../../static/images/contact/服务热线.png" alt="">
              <div class="label visd">服务热线：</div>
              <div class="text">章先生（+86 191 2839 0686 / +86 138 0989 7866）</div>
            </div>
            <div class="item">
              <img src="../../static/images/contact/邮箱.png" alt="">
              <div class="label">服务邮箱：</div>
              <div class="text">何女士（aheli@levimelt.com）</div>
            </div>
            <div class="item">
              <img class="visd" src="../../static/images/contact/邮箱.png" alt="">
              <div class="label visd">服务邮箱：</div>
              <div class="text">章先生（sales@levimelt.com）</div>
            </div> -->
          </div>
          <div class="right">
            <baidu-component
              class="bm-view"
              ak="UmeYALQE9awE98LBNtNivQfr8hEoNP7W"
            ></baidu-component>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section2">
      <div class="s2_innerBox typeArea">
        <div class="bodyBox">
          <div class="item item1">
            <div class="p1">浙江中试基地</div>
            <div class="btBox">
              <div class="label">浙江省金华市武义县胡宅垄工业区</div>
            </div>
          </div>
          <div class="item item2">
            <div class="p1">上海销售中心</div>
            <div class="btBox">
              <div class="label">
                上海浦东新区杨高南路799号陆家嘴世纪金融广场3号楼(9层)911室
              </div>
              <div class="label">+86 131 2236 9456</div>
            </div>
          </div>
          <div class="item item3">
            <div class="p1">南京销售中心</div>
            <div class="btBox">
              <div class="label">
                南京市江宁区南京南站南广场绿地城际空间站A-1,1813室
              </div>
              <div class="label">+86 198 5090 5866</div>
            </div>
          </div>
          <div class="item item4">
            <div class="p1">成都销售中心</div>
            <div class="btBox">
              <div class="label">成都市武侯区航空路1号国航世纪中心B座701</div>
              <div class="label">+86 186 8155 9268</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section3">
      <div class="s3_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">在线<span>留言</span></div>
          <div class="p2"></div>
          <div class="p3">ONLINE MESSAGE</div>
        </div>
        <div class="bodyBox">
          <el-input
            class="input"
            v-model="input1"
            placeholder="您的姓名："
          ></el-input>
          <el-input
            class="input"
            v-model="input2"
            placeholder="联系电话："
          ></el-input>
          <el-input
            class="input"
            v-model="input3"
            placeholder="联系邮箱："
          ></el-input>
          <el-input
            type="textarea"
            :rows="5"
            placeholder="留言内容："
            v-model="textarea"
          >
          </el-input>
        </div>
        <div class="btn">
          <div class="boxT" @click="btnFunc()">提交留言</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaiduComponent from "@/components/baiduMap";
export default {
  name: "contact",
  components: {
    BaiduComponent,
  },
  data() {
    return {
      textarea: "",
      input1: "",
      input2: "",
      input3: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    this.init();
  },
  mounted() {
    this.$store.commit("savePageId", "");
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  methods: {
    downLoad(type) {
      let a = document.createElement("a");
      if (type == 1) {
        a.href = "./static/images/contact/李亮名片PC.jpg";
        a.download = "李亮名片.jpg";
      } else if (type == 2) {
        a.href = "./static/images/contact/章桂华名片PC.jpg";
        a.download = "章桂华.jpg";
      } else if (type == 3) {
        a.href = "./static/images/contact/何利名片PC.jpg";
        a.download = "何利.jpg";
      } else {
        a.href = "./static/images/contact/李志平名片PC.jpg";
        a.download = "李志平.jpg";
      }
      a.click();
    },
    init() {},
    btnFunc() {
      if (this.input1 == "") {
        this.$message.error("请填写您的姓名");
      } else if (this.input2 == "") {
        this.$message.error("请填写您的联系电话");
      } else if (this.input3 == "") {
        this.$message.error("请填写您的联系邮箱");
      } else if (this.textarea == "") {
        this.$message.error("请填写留言内容");
      } else {
        this.$message({
          type: "success",
          message: "感谢提交，我们已收到您的留言",
          center: true,
        });
        this.input1 = "";
        this.input2 = "";
        this.input3 = "";
        this.textarea = "";
      }
    },
  },
};
</script>

<style lang='less' scoped>
.contact {
  width: 100%;
  min-width: 1200px;

  .section1 {
    width: 100%;
    height: 830px;

    .s1_innerBox {
      height: 100%;

      .topTitle {
        .p1 {
          margin-top: 193px;
        }
      }

      .bodyBox {
        display: flex;
        margin-top: 130px;
        position: relative;

        .left {
          width: 586px;
          text-align: left;
          margin-right: 20px;
          position: relative;
          .downLoad {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 80px;
            height: 25px;
            border: solid 1px #c30000;
            font-size: 14px;
            color: #c30000;
            line-height: 25px;
            text-align: center;
            right: 5px;
            bottom: -35px;
            cursor: pointer;
            z-index: 999;
          }
          /deep/ .el-carousel {
            .el-carousel__container {
              height: 340px;

              .el-carousel__arrow {
                display: none;
              }

              .el-carousel__item {
                display: flex;
                justify-content: space-between;
                overflow: initial;
                img {
                  height: 100%;
                }
              }
            }

            .el-carousel__indicators {
              margin-top: 20px;

              .el-carousel__button {
                width: 30px;
                height: 6px;
                background-color: #cccccc;
              }

              .is-active {
                .el-carousel__button {
                  width: 50px;
                  height: 6px;
                  background-color: #c30000;
                }
              }
            }
          }

          .p1 {
            font-size: 30px;
            line-height: 30px;
            color: #333333;
            font-weight: 400;
            margin-bottom: 26px;
          }

          .line {
            width: 100%;
            height: 1px;
            background-color: #e4ebf2;
            margin-bottom: 37px;
          }

          .item {
            display: flex;
            // justify-content: center;
            align-items: center;
            font-size: 16px;
            line-height: 38px;
            color: #545454;
            font-weight: 400;

            .visd {
              visibility: hidden;
            }

            img {
              margin-right: 20px;
            }

            .label {
            }
          }

          .item1 {
            margin-bottom: 16px;
          }

          .item2 {
            margin-bottom: 16px;
          }
        }

        .right {
          flex: 1;
          width: 594px;
          height: 340px;
          // position: absolute;
          // right: 0;
          // bottom:0;
        }
      }
    }
  }

  .section2 {
    width: 100%;
    height: 800px;
    background-color: #fbfbfb;

    .s2_innerBox {
      height: 100%;

      .bodyBox {
        padding-top: 90px;
        height: 480px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .item {
          width: 590px;
          height: 240px;
          margin-bottom: 10px;
          background-color: #ffffff;
          box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.1);
          background-repeat: no-repeat;
          position: relative;

          .p1 {
            width: 137px;
            height: 35px;
            line-height: 35px;
            background-color: #c30000;
            font-size: 18px;
            font-size: 18px;
            color: #ffffff;
            font-weight: 400;
            margin: 12px;
          }

          .btBox {
            text-align: left;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100px;
            background-color: rgba(0, 0, 0, 0.4);
            font-size: 16px;
            line-height: 40px;
            font-weight: 400;
            color: #ffffff;
            padding: 5px 12px 0;
          }
        }

        .item1 {
          background-image: url("../../static/images/contact/浙江.jpg");
        }
        .item2 {
          background-image: url("../../static/images/contact/上海.jpg");
        }
        .item3 {
          background-image: url("../../static/images/contact/南京.jpg");
        }
        .item4 {
          background-image: url("../../static/images/contact/成都.jpg");
        }
      }
    }
  }

  .section3 {
    width: 100%;
    height: 830px;

    .s3_innerBox {
      height: 100%;

      .topTitle {
        .p1 {
          margin-top: 150px;
        }
      }

      .bodyBox {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 78px;

        .input {
          width: 379px;

          /deep/ .el-input__inner {
            background-color: #fbfbfb;
            color: #333333;
          }
          /deep/ .el-input__inner:focus {
            border-color: #c30000;
          }
        }

        /deep/ .el-textarea {
          margin-top: 40px;

          .el-textarea__inner {
            background-color: #fbfbfb;
            color: #333333;
          }
          .el-textarea__inner:focus {
            border-color: #c30000;
          }
        }
      }

      .btn {
        display: flex;
        justify-content: center;
        margin-top: 50px;

        .boxT {
          width: 250px;
          height: 50px;
          line-height: 50px;
          background-color: #c30000;
          color: #ffffff;
          font-size: 18px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contact.vue